<template>
    <fb-list-body :pager="pager"
                  @handlePagerSizeChange="handlePagerSizeChange"
                  @handlePagerIndexChange="handlePagerIndexChange"
    >

        <template slot="btn-group">
            <el-button  icon="el-icon-plus" @click="$router.push('add' )">新增</el-button>
            <el-button icon="el-icon-edit"  @click.stop="handleEdit">编辑</el-button>
            <el-button icon="el-icon-delete" @click.native="handleBatchDelete">删除</el-button>
        </template>



        <template slot="search-form">


            <el-form-item class="search-form-item" label="设备厂商">
                <dict-select type-flag="SPDEV_MFG" v-model="searchForm.mfg" clearable></dict-select>
            </el-form-item>

            <el-form-item class="search-form-item" label="设备SN">
                <el-input v-model="searchForm.sn" placeholder="设备SN"></el-input>
            </el-form-item>

            <el-form-item class="search-form-item" label="设备编号">
                <el-input v-model="searchForm.number" placeholder="设备编号"></el-input>
            </el-form-item>


            <el-form-item class="search-form-item" label="激活状态">
                <dict-select type-flag="SPDEV_ACTIVE_STATUS" v-model="searchForm.activeStatus" clearable></dict-select>
            </el-form-item>

            <el-form-item class="search-form-item" label="设备状态">
                <dict-select type-flag="SPDEV_STATUS" v-model="searchForm.status" clearable></dict-select>
            </el-form-item>


            <el-button icon="el-icon-search" size="mini" type="primary" @click.stop="handleSearch">查询</el-button>

        </template>

        <template slot="table">
            <el-table :data="tableData"  @selection-change="handleSelectionChange">

                <el-table-column
                        type="selection"
                        width="50">
                </el-table-column>

                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>

                <el-table-column
                        prop="name"
                        label="名称"
                        >
                </el-table-column>

                <el-table-column
                        prop="flag"
                        label="标识"
                >
                </el-table-column>


                <el-table-column
                        fixed="right"
                        label="操作"
                       >
                    <template slot-scope="scope">

                        <el-link type="primary" @click="handleEdit(scope.row)" :underline="false" >编辑</el-link>

                        <el-link type="danger"  @click="handleDelete(scope.row)" :underline="false" style="margin-left: 10px;">删除</el-link>
                    </template>
                </el-table-column>


            </el-table>
        </template>


    </fb-list-body>
</template>

<script>

    import {Loading} from "element-ui";

    export default {
        name: "SpdeivceList",
        components: {},
        props:{
          timestamp:{type:Number,default:function () {
                  return new Date().getTime()
              }},
        },
        data() {
            return {
                api:{
                    list:this.$api.spDevServer.list,
                    delete:this.$api.spDevServer.delete,
                    batchDelete:this.$api.spDevServer.batchDelete,
                },
                searchForm: {},
                tableData:[],
                selection:[],
                pager: {
                    pageSize: 10
                    , pageIndex: 1,
                    itemCount: 0
                }
            }
        },
        computed: {
            searchParams() {
                return Object.assign({}, this.$route.query,this.searchForm,this.pager);
            }
        },
        watch:{
            "$route.query":{
                handler() {
                    this.pageIndex=1;
                    this.handleSearch();
                },
                deep:true,
                immediate:true
            },
            "pager.pageIndex":{
                handler() {
                    this.handleSearch();

                },
                deep:true,
                immediate:true
            },
            "pager.pageSize":{
                handler() {
                    this.handleSearch();

                },
                deep:true
            }
        },
        methods: {
            handleDeleteAll(){
                let vm = this;

                vm.$confirm('您正在进行数据清空操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.$api.quoteBaseData.deleteAll).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });
            },
            handleImport(){
                let vm = this;
                let input = document.createElement("input");
                input.type = "file";
                input.multiple = true;
                input.onchange = async () => {

                    if (input.files && input.files.length) {


                        let loading = Loading.service({fullscreen: false, text: '文件上传中...'});

                        //开始上传文件
                        let formData = new FormData();
                        formData.append("file", input.files[0]);
                        formData.append("category", vm.category);

                        let res = await vm.$http.post(vm.$api.quoteBaseData.importData, formData);

                        loading.close();
                        if (res.data.status === 200) {
                            vm.$message({type:'success',message:`成功导入${res.data.data.count}条数据`});

                            vm.pager.pageIndex = 1;
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:`导入失败`});

                        }

                    } else {
                        vm.$emit('input', '')
                    }

                };
                input.click();
            },
            handleEdit(e) {

                if(e && e.code){
                    this.$router.push({path:'edit',query:{code:e.code}});
                    return;
                }

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }

                if(this.selection.length > 1){
                    this.$message({type:'warning',message:'一次只能编辑一条数据'});
                    return ;
                }

                this.$router.push({path:'edit',query:{code:this.selection[0].code}});
            },
            handleDelete(row){


                let vm = this;

                vm.$confirm('您现在正在进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(vm.api.delete,vm.$qs.stringify({code:row.code})).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });

            },
            handleBatchDelete() {


                let vm = this;

                if(!this.selection.length){
                    this.$message({type:'warning',message:'未选择记录'});
                    return ;
                }


                let codes = [];

                this.selection.forEach((e)=>{
                    codes.push(e.code);
                });


                this.$confirm('您现在正在进行批量删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    vm.$http.post(this.api.batchDelete,codes).then((resp)=>{
                        if(resp.data.status === 200){
                            vm.$message({type:'success',message:resp.data.desc});
                            vm.handleSearch();
                        }else{
                            vm.$message({type:'error',message:resp.data.desc});

                        }
                    })



                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });
                });




            },
            handleSelectionChange(selection){
                console.log(selection);
                this.selection = selection;
            },
            handlePagerSizeChange(e){
                this.pager.pageSize = e;
            },
            handlePagerIndexChange(e){
                this.pager.pageIndex = e;
            },
            handleSearch() {
                let vm = this;
                this.$http.post(this.api.list,this.$qs.stringify(this.searchParams)).then((resp)=>{


                    for(let key in resp.data.data){
                        if(resp.data.data[key] instanceof Array){
                            vm.tableData = resp.data.data[key];
                        }
                    }

                    //处理分页
                    vm.pager.pageIndex = resp.data.data.pager.pageIndex;
                    vm.pager.pageSize = resp.data.data.pager.pageSize;
                    vm.pager.itemCount = resp.data.data.pager.itemCount;

                })
            },
            handleDownTemplate(){
                window.open(this.$api.quoteBaseData.downloadTemplate);
            }
        },
        created() {
            for (let key in this.searchForm){
                 if(this.$route.query[key]){
                     this.searchForm[key]= this.$route.query[key];
                 }
            }
        }
    }
</script>

<style scoped>

</style>